import mc from '../../api/mc'
import initdata from '../../api/initdata'
import Toucth from '../../assets/js/method.js'
import cookieJS from 'js-cookie'
import JSONBig from 'json-bigint-xk'

const Tool = Toucth
const state = {
  phoneNo: '', // 电话号码
  loginState: true, // 是否是登录
  loginData: {
    openId: null,
    passenger: null,
    token: null
  }, // 登录信息
  wxState: null,
  imgUrl: null
}

const mutations = {
  loginAction (state, obj) { // 设置登录状态
    state.loginState = obj.state
  },
  accredit (state, obj) {
    state.wxState = obj.wxState
  },
  checkLogin (state, fn) {
    let passengerkey = window.configure.passengerKey
    let passenger = cookieJS.get(passengerkey) ? JSONBig.parse(Tool.aesDecryptCode(cookieJS.get(passengerkey))) : null
    // if (passenger) {
    //   // console.log('检查', passenger)
    //   window.configure.passengerInfo = passenger.passenger
    //   if (passenger) {
    //     if (state.wxState && passenger.openId) {
    //       state.loginState = true
    //       state.loginData = passenger
    //       state.phoneNo = passenger.passenger.phone
    //       if (fn) {
    //         fn(true)
    //       }
    //       return true
    //     } else if (!state.wxState) {
    //       state.loginState = true
    //       state.loginData = passenger
    //       state.phoneNo = passenger.passenger.phone
    //       if (fn) {
    //         fn(true)
    //       }
    //       return true
    //     }
    //   } else if (state.wxState && passenger.openId) {
    //     state.loginState = true
    //     state.loginData = passenger
    //     if (fn) {
    //       fn(true)
    //     }
    //     return true
    //   } else if (fn) {
    //     fn(false)
    //   }
    //   return false
    // } else {
    //   if (fn) {
    //     fn(false)
    //   }
    // }
    if (passenger) {
      window.configure.passengerInfo = passenger.passenger
      if (!state.wxState) { // 非微信环境
        console.log('检查登录--非微信环境', passenger)
        state.loginState = true
        state.loginData = passenger

        state.phoneNo = passenger.passenger.phone
        if (fn) {
          fn(true)
        }
        return true
      } else if (state.wxState && passenger.openId) { // 微信环境
        console.log('检查登录--微信环境')
        state.loginState = true
        state.loginData = passenger
        state.phoneNo = passenger.passenger.phone
        if (fn) {
          fn(true)
        }
        return true
      } else if (state.wxState && !passenger.openId) { // 微信环境，但没有openid
        console.log('检查登录--微信环境，但没有openid')
        state.loginState = false
        if (fn) {
          fn(false)
        }
        return false
      }
    } else { // cookie信息不存在
      console.log('检查登录--cookie信息不存在')
      state.loginState = false
      if (fn) {
        fn(false)
      }
      return false
    }
  },
  updateLoginData (state, data) {
    if (data.data.code === 1) {
      state.loginData.passenger = data.data.passenger
      state.loginData.token = data.data.token
      state.loginData.grade = data.data.grade
      let passengerkey = window.configure.passengerKey
      cookieJS.remove(passengerkey)
      cookieJS.set(passengerkey, Tool.aesEncryptCode(JSON.stringify(state.loginData)))
      if (data.fn) {
        data.fn(data)
      }
    }
  },
  getOpenId (state, data) {
    if (data && data.code === 1) {
      cookieJS.set('open_id', data.wechat.open_id)
      window.configure.open_id = data.wechat.open_id
    } else {
      window.configure.open_id = cookieJS.get('open_id')
    }
  },
  logoutUser (state, fn) { // 注销
    let passengerkey = window.configure.passengerKey
    Tool.delCookie(passengerkey)
    let passanger = cookieJS.get(passengerkey)
    if (passanger) {
      cookieJS.remove(passengerkey)
    }
    Tool.delCookie('easyminaddressrecord')
    state.loginState = false
  },
  setPassengerInfo (state, passInfo) {  // 写入 用户信息
    if (passInfo.passenger.code === 1) {
      state.loginData.passenger = passInfo.passenger.passenger
      window.configure.passengerInfo = passInfo.passenger.passenger
      state.loginData.openId = passInfo.passenger.passenger.open_id
      let appKey = passInfo.passenger.passenger.app_key
      window.configure.passengerKey = 'passenger' + appKey // window上记录存下的用户信息名称
      window.configure.appKey = appKey // window上记录代驾公司的appKey
      let passengerkey = window.configure.passengerKey // 用户信息命名用
      Tool.setCookie(passengerkey, Tool.aesEncryptCode(JSON.stringify(state.loginData))) // 将该代驾公司登录的用户写入cookie
      state.loginState = true
      console.log('loginState1111111111111', state.loginState)
      console.log('passengerkey', passengerkey, Tool.aesEncryptCode(JSON.stringify(state.loginData)))
      // let passengerkey = window.configure.passengerKey
      // Tool.setCookie(passengerkey, Tool.aesEncryptCode(JSON.stringify(state.loginData)))
      // state.loginState = true
      // console.log('loginState', state.loginState)
      // console.log('passengerkey', Tool.aesEncryptCode(JSON.stringify(state.loginData)))
      if (passInfo.fn) {
        passInfo.fn(true)
      }
    } else {
      passInfo.fn(false, passInfo.passenger.code)
    }
  },
  loginOpenId (state, obj) {
    if (obj.code === 1) {
      state.loginData.passenger = obj.passenger
      window.configure.passengerInfo = obj.passenger
      state.loginData.openId = obj.passenger.open_id
      let appKey = obj.passenger.app_key
      window.configure.passengerKey = 'passenger' + appKey
      window.configure.appKey = appKey
      let passengerkey = window.configure.passengerKey
      Tool.setCookie(passengerkey, Tool.aesEncryptCode(JSON.stringify(state.loginData)))
      // let appkey = this.$route.query.app_key || window.configure.appKey
      // let key = 'passenger' + appkey
      // Tool.setCookie(key, Tool.aesEncryptCode(JSON.stringify(state.loginData)))
      state.loginState = true
      if (obj.fn) {
        obj.fn(true)
      }
    } else {
      let appkey = window.configure.appKey
      let key = 'passenger' + appkey
      Tool.delCookie(key)
      state.loginState = false
      if (obj.fn) {
        obj.fn(false)
      }
    }
    // if (obj.data.code === 0) {
    //   state.loginData = obj.data.data
    // }
    // if (obj.data.code === 0 && state.loginData.passenger) {
    //   Tool.setCookie('passenger', JSON.stringify(state.loginData))
    //   state.loginState = true
    // } else {
    //   if (obj.prestrain) {
    //     state.loginState = true
    //   } else {
    //     state.loginState = false
    //   }
    // }
  },
  checkWX (state, data) {
    state.wxState = data
  }
}

const getters = {
  login: state => {
    return state.loginState
  },
  loginData: state => {
    window.configure['passengerInfo'] = state.loginData.passenger
    return state.loginData
  },
  wxState: state => {
    return state.wxState
  }
}

const actions = {
  loginAction ({commit}, obj) { // 设置登录状态
    commit('loginAction', obj)
  },
  accredit ({commit}, fn) {
    initdata.accredit(fn, (data) => {
      if (data && fn) {
        fn(data)
      }
      commit('accredit', data)
    })
  },
  getWeChatToken ({commit}, obj) {
    mc.getWeChatToken(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  checkLogin ({commit}, fn) {
    commit('checkLogin', fn)
  },
  updateLoginData ({commit}, obj) {
    mc.updateLoginData(obj, (data) => {
      commit('updateLoginData', {
        data: data,
        fn: () => {
          if (data && obj.fn) {
            obj.fn(data)
          }
        }
      })
    })
  },
  logoutUser ({commit}, obj) { // 注销
    if (obj.fn) {
      obj.fn(true)
    }
    commit('logoutUser')
  },
  getOpenId ({commit}, obj) { // 获取openID
    mc.getOpenId(obj, (data) => {
      commit('getOpenId', data)
      if (data && obj.fn) {
        obj.fn(data)
      }
    })
  },
  postloginOpenId ({commit}, obj) { // 获取openID
    mc.postloginOpenId(obj, (data) => {
      if (data && obj.fn) {
        obj.fn(data)
      }
      commit('loginOpenId', data)
    })
  },
  checkWX ({commit}, obj) { // 检查是不是微信
    initdata.checkWX(obj, (state) => {
      if (obj.fn) {
        obj.fn(state)
      }
      commit('checkWX', state)
    })
  },
  getCheckUser ({commit}, obj) {  // 检查账户是否存在
    mc.getCheckUser(obj, (state) => {
      if (obj.fn) {
        obj.fn(state)
      }
    })
  },
  getImgCode ({commit}, obj) {  // 获取 图片验证码
    mc.getImgCode(obj, (state) => {
      if (obj.fn) {
        obj.fn(state)
      }
    })
  },
  postCheckCode ({commit}, obj) {  // 验证  验证码是否正确
    mc.postCheckCode(obj, (state) => {
      if (obj.fn) {
        obj.fn(state)
      }
    })
  },
  getSmsCode ({commit}, obj) {  // 验证  获取 短信验证码
    mc.getSmsCode(obj, (state) => {
      if (obj.fn) {
        obj.fn(state)
      }
    })
  },
  postLogin ({commit}, obj) {  // 登录
    mc.postLogin(obj, (passenger) => {
      commit('setPassengerInfo', {passenger: passenger, fn: obj.fn})
    })
  },
  passengerWithOutLogin ({commit}, obj) { // 免登
    mc.passengerWithOutLogin(obj, (passenger) => {
      commit('setPassengerInfo', {passenger: passenger, fn: obj.fn})
    })
  },
  getPassenger ({commit}, obj) { // 获取 用户信息(根据appkey和openid)
    mc.getPassenger(obj, (data) => {
      commit('updateLoginData', {data: data, fn: obj.fn})
    })
  },
  putPassenger ({commit}, obj) { // 编辑 用户信息
    mc.putPassenger(obj, (data) => {
      if (obj.fn) {
        obj.fn(data)
      }
    })
  },
  postRegister ({commit}, obj) {  // 注册
    mc.postRegister(obj, (passenger) => {
      commit('setPassengerInfo', {passenger: passenger, fn: obj.fn})
      if (obj.fn) {
        obj.fn(passenger)
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/mc.js